import BaseBarStack from "./private/BaseBarStack.js";
import AnimatedBars from "./private/AnimatedBars.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedBarStack(props) {
  return /*#__PURE__*/_jsx(BaseBarStack, {
    ...props,
    BarsComponent: AnimatedBars
  });
}